import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useAddTruck() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const addTruck = useCallback(
    async (item) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return null;
      }
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        const response = await API.post(`/users/${uid}/truck`, item);
        setSuccess(true);
        return response?.data || null;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { addTruck, loading, error, success };
}
